import '../styles/rules.css';
import { useTranslation } from '../hooks/useTranslation';
import SEO from '../components/SEO';

const Terms = () => {
  const { t } = useTranslation();

  const createMarkup = (htmlString) => {
    return { __html: htmlString };
  };

  return (
    <div>
      <SEO
        title="Пользовательское соглашение — Diamond VPN"
        description="Пользовательское соглашение Diamond VPN: условия использования сервиса, права и обязанности сторон, ограничения и правила возврата."
        ogImage="https://diamondvpn.online/preview.jpg"
      />
      <div className="rules-content" data-aos="fade-up">
        <div className="rules-container">
          <h1>{t('terms.title')}</h1>
      
          <p>{t('terms.lastUpdated')}</p>

          <h2>{t('terms.sections.general')}</h2>
          <ol>
            {t('terms.content.general.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <h2>{t('terms.sections.subject')}</h2>
          <ol>
            {t('terms.content.subject.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <h2>{t('terms.sections.ownerRights')}</h2>
          <ol>
            {t('terms.content.ownerRights.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <h2>{t('terms.sections.userRights')}</h2>
          <ol>
            {t('terms.content.userRights.items').map((item, index) => {
              if (index === 2 && typeof item === 'string') {
                return (
                  <li key={index}>
                    {item}
                    <ul className="ul-items">
                      {t('terms.content.userRights.prohibitedItems').map((prohibitedItem, prohibitedIndex) => (
                        <li key={prohibitedIndex}>{prohibitedItem}</li>
                      ))}
                    </ul>
                  </li>
                );
              }
              return <li key={index}>{item}</li>;
            })}
          </ol>
          
          <h2>{t('terms.sections.responsibility')}</h2>
          <ol>
            {t('terms.content.responsibility.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <h2>{t('terms.sections.ethics')}</h2>
          <ol>
            {t('terms.content.ethics.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>
          
          <h2>{t('terms.sections.final')}</h2>
          <ol>
            {t('terms.content.final.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>
          
        </div>
      </div>
    </div>
  );
};

export default Terms;
